export default __webpack_public_path__ + "static/media/mestamask.17050ef6.png";